module.exports = __webpack_public_path__ + "media/iconic/x-thin-b94cec9a.svg";